import { MenuItem, MenuItemOptionSetItem } from '../core/api/menu/menu.types';
import * as ServiceCharge from './ServiceCharge';
import * as Vouchers from './Vouchers';

export class Item {
  public Count?: number;

  public Item: MenuItem;

  public Options: MenuItemOptionSetItem[];
}

export interface Data {
  excludeServiceCharge: boolean;
  items: Item[];
  menuId: number;
  requestedTime: string;
  serviceCharge: ServiceCharge.States;
  voucher: Vouchers.States;
}

export const Empty: Data = {
  excludeServiceCharge: false,
  items: [],
  menuId: 0,
  requestedTime: '',
  serviceCharge: ServiceCharge.Default,
  voucher: Vouchers.Default,
};
